// Explicit because unplugin-auto-import is registered only in vite.config.ts, so these globals do
// not exist once a test pulls this module in. Harmless in the build: auto-import skips them.
import { ref, type Ref } from "vue";
import { TicketPurchaseDtoViewModel } from "@/viewmodels.g";

const originalPurchase: Ref<TicketPurchaseDtoViewModel | undefined> =
  ref(undefined);

/**
 * This is to be used in exchange purchase use-case scenarios
 * @param exchangePurchase
 */
export default function useExchange(
  exchangePurchase: TicketPurchaseDtoViewModel | null,
) {
  if (!exchangePurchase?.originalPurchase?.publicId) {
    originalPurchase.value = undefined;
    return { originalPurchase };
  }

  originalPurchase.value = new TicketPurchaseDtoViewModel();
  originalPurchase.value.$load(exchangePurchase.originalPurchase.publicId);
  return { originalPurchase };
}
